'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWbIridescent = function MdWbIridescent(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.3 33.3l-2.4-2.4 3-3 2.4 2.3z m-2.4-25.9l2.4-2.3 3 2.9-2.4 2.4z m28.2 23.5l-2.4 2.4-2.9-3.1 2.3-2.3z m-12.5 6.5h-3.2v-4.9h3.2v4.9z m10.1-32.3l2.4 2.3-3 3-2.3-2.3z m-13.3-4.2h3.2v5h-3.2v-5z m-10 23.2v-10h23.2v10h-23.2z' })
        )
    );
};

exports.default = MdWbIridescent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wb-iridescent.js
// module id = 3463
// module chunks = 0